import { Question } from '@/types/slide';
import MuiCard from '@mui/material/Card';
import MuiTypography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import React, { useCallback } from 'react';
import { ResultCardAudioRecord } from './cards/ResultCardAudioRecord';
import { ResultCardCharacterCard } from './cards/ResultCardCharacterCard';
import { ResultCardCharacterWriting } from './cards/ResultCardCharacterWriting';
import { ResultCardDnd } from './cards/ResultCardDnd';
import { ResultCardDrawing } from './cards/ResultCardDrawing';
import { ResultCardMC } from './cards/ResultCardMC';
import { ResultCardPronunciationAssessment } from './cards/ResultCardPronunciationAssessment';
import { ResultCardRadicalWriting } from './cards/ResultCardRadicalWriting';
import { ResultCardSentenceMaker } from './cards/ResultCardSentenceMaker';
import { ResultCardStrokeWriting } from './cards/ResultCardStrokeWriting';
import { ResultCardUnsupported } from './cards/ResultCardUnsupported';
import { ResultCardCharacter } from './legacy/ResultCardCharacter.legacy';
import { ResultCardHkcsEnQ1 } from './legacy/ResultCardHkcsEnQ1.legacy';
import { ResultCardHkcsEnQ2 } from './legacy/ResultCardHkcsEnQ2.legacy';
import { ResultCardHkcsQ1 } from './legacy/ResultCardHkcsQ1.legacy';
import { ResultCardHkcsQ2 } from './legacy/ResultCardHkcsQ2.legacy';
import { ResultCardHkcsQ3 } from './legacy/ResultCardHkcsQ3.legacy';

export const ResultTitle = styled(MuiTypography)(() => ({}));

export const ResultContent = styled('div')(({ theme }) => ({
    minHeight: '320px',
    alignContent: 'center',
    flexGrow: 1,

    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
}));

export const ResultContainer = styled(MuiCard)(({ theme }) => ({
    height: '100%',

    border: 0,
    borderRadius: 4,
    backgroundColor: (theme.vars || theme).palette.grey[100],
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    ...theme.applyStyles('dark', {
        backgroundColor: (theme.vars || theme).palette.grey[800],
    }),
}));

export const ResultCard: React.FC<{ question: Question }> = ({ question }) => {
    const RenderResultCard = useCallback(() => {
        switch (question.type) {
            case 'character':
                return <ResultCardCharacter question={question} />;
            case 'characterWriting':
                return <ResultCardCharacterWriting question={question} />;
            case 'drawing':
                return <ResultCardDrawing question={question} />;
            case 'hkcsQ1':
                return <ResultCardHkcsQ1 question={question} />;
            case 'hkcsQ2':
                return <ResultCardHkcsQ2 question={question} />;
            case 'hkcsQ3':
                return <ResultCardHkcsQ3 question={question} />;
            case 'hkcsEnQ1':
                return <ResultCardHkcsEnQ1 question={question} />;
            case 'hkcsEnQ2':
                return <ResultCardHkcsEnQ2 question={question} />;
            case 'dnd':
                return <ResultCardDnd question={question} />;
            case 'pronunciationAssessment':
                return <ResultCardPronunciationAssessment question={question} />;
            case 'audioRecord':
                return <ResultCardAudioRecord question={question} />;
            case 'characterCards':
                return <ResultCardCharacterCard question={question} />;
            case 'strokeWriting':
                return <ResultCardStrokeWriting question={question} />;
            case 'radicalWriting':
                return <ResultCardRadicalWriting question={question} />;
            case 'mc':
                return <ResultCardMC question={question} />;
            case 'sentenceMaker':
                return <ResultCardSentenceMaker question={question} />;
            default:
                return <ResultCardUnsupported question={question} />;
        }
    }, [question]);

    return <RenderResultCard />;
};
